import type { Order } from '@commercelayer/sdk'

/**
 * Hands the order returned by `place()` to the thank-you page.
 *
 * Commerce Layer only lets a token read the orders it owns, and the guest token
 * in `localStorage` is not always still the one that placed the order — so that
 * page's own fetch can 401 on an order the customer has already paid for.
 *
 * @returns {Object} `setPlacedOrder` to store the order, `getPlacedOrder` to read it back.
 */
export const usePlacedOrder = () => {
  const placedOrder = useState<Order | null>('placed-order', () => null)

  const setPlacedOrder = (order: Order) => {
    placedOrder.value = order
  }

  // The id check lives here because a stored order outlives the page that
  // stored it: without it, a second order would render the previous one.
  const getPlacedOrder = (orderId: string) =>
    placedOrder.value?.id === orderId ? placedOrder.value : null

  return { setPlacedOrder, getPlacedOrder }
}
